export const urlAvatar = '/static/avatar/'
